import { Component, OnInit, Signal } from '@angular/core';
import { DatatableComponent } from '@app/datatables/models/custom-datatable-extension';
import { SelectionDescription } from '@app/shared/models/selection-description';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'portal-check-column-header',
  templateUrl: './check-column-header.component.html',
  standalone: false,
})
export class CheckColumnHeaderComponent extends DatatableComponent implements OnInit {
  allSelected = false;

  iconMapping: Record<'none' | 'some' | 'all', string> = {
    some: 'far fa-minus-circle',
    none: 'far fa-circle',
    all: 'far fa-check-circle',
  };

  selectionDescription: SelectionDescription = 'none';

  data: Signal<any[]>;

  ngOnInit(): void {
    this.datatablePage.selectedEntriesDescription$.pipe(untilDestroyed(this)).subscribe(({ current }) => {
      this.allSelected = current === 'all';
      this.selectionDescription = current;
    });

    this.data = this.datatablePage.data;
  }

  toggleAll(): void {
    this.datatablePage.toggleCurrentView();
  }
}
